import React, { useContext } from 'react'
import { useParams } from 'react-router-dom'
import { WorkflowContext } from 'components/GeneralUI/WorkflowWindowContainer/WorkflowWindowContainer.jsx'

const withWorkflow = () => {
  return WrappedComponent => {
    const WithWorkflow = props => {
      const nextStep = useContext(WorkflowContext)
      const { workflow } = useParams()
      const inWorkflow = workflow != null
      return <WrappedComponent {...props} nextStep={nextStep} inWorkflow={inWorkflow} />
    }
    return WithWorkflow
  }
}

export default withWorkflow
